<!--suppress HtmlFormInputWithoutLabel -->
<template>
  <div class="profile-wrapper">
    <section v-if="profile" class="profile-tags">
      <h3>{{ $t('profile.My interests') }}</h3>
      <p class="desc">
        {{ $t('profile.interestsHelpString') }}
      </p>
      <div class="interests two columns">
        <div v-for="tagType in tagTypes" :key="tagType" class="column">
          <div>{{ $t(`profile.tags.type.${tagType}`) }}</div>
          <box-with-badge :value="numPeopleOfTag(tagType)">
            <button class="mini desc" @click="showPeopleOfTag(tagType)">
              {{ $t(`profile.${numPeopleOfTag(tagType) ? 'People' : 'Nobody'} with similar interests`) }}
            </button>
          </box-with-badge>
          <tags-input
            :create-tag="createTagFn(tagType)"
            :query="queryTagsFn()"
            :value="typedTags[tagType]"
            @append="appendTag[tagType]">
            <tag-item
              v-for="(tag, index) in typedTags[tagType]"
              :key="index"
              :tag="tag"
              tags-privacy
              @remove="removeTag[tagType]">
              <tag-privacy-popup :tag="tag" :tag-type="tagType" class="guarded-title-wrap" @input="setTag[tagType]" />
            </tag-item>
          </tags-input>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import TagsInput from '../components/UI/TagsInput'
import TagItem from '../components/UI/TagItem'
import TagPrivacyPopup from '../components/UI/TagPrivacyPopup'
import BoxWithBadge from '../components/UI/BoxWithBadge'
import Profile from '../../lib/profile'
import ProfileTags from '../../lib/profile-tags'
import Tags from '../../lib/tags'

export default {
  name: 'UserInterests',
  components: {
    TagsInput,
    TagItem,
    TagPrivacyPopup,
    BoxWithBadge
  },

  data () {
    return {
      records: {}
    }
  },

  computed: {
    ...mapState(['user']),
    ...mapState('profile', ['profile']),

    tagTypes () {
      return ProfileTags.tagTypes
    },
    /**
     * @return {Object.<string, ProfileTag[]>}
     */
    typedTags () {
      return this.tagTypes.reduce((result, type) => ({
        ...result,
        [type]: Object.entries((this.profile.tags || {})[type] || {})
          .map(([id, userTag]) => ({ ...userTag, id }))
      }), {})
    },
    appendTag () {
      return this.tagTypes.reduce((result, tagType) => ({
        ...result,
        [tagType]: this.appendTagFn(tagType)
      }), {})
    },
    removeTag () {
      return this.tagTypes.reduce((result, tagType) => ({
        ...result,
        [tagType]: this.removeTagFn(tagType)
      }), {})
    },
    setTag () {
      return this.tagTypes.reduce((result, tagType) => ({
        ...result,
        [tagType]: this.setTagFn(tagType)
      }), {})
    }
  },

  watch: {
    '$route': function () {
      this.fetch()
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    ...mapMutations('profile', ['set']),
    ...mapActions('profile', ['requestToShowPeopleOfTagType']),

    numPeopleOfTag (tagType) {
      return this.records[tagType] ? this.records[tagType].length : 0
    },

    showPeopleOfTag (tagType) {
      this.requestToShowPeopleOfTagType(tagType)
    },

    queryTagsFn (type) {
      return value => Tags.query(value, type)
    },
    createTagFn (type) {
      return title => {
        if (title) {
          return ProfileTags.createTag(Tags.createTag(title, type))
        }
        return null
      }
    },
    appendTagFn (type) {
      return ({ title }) => {
        const tag = ProfileTags.createTag(Tags.createTag(title, type))
        this.set({ name: 'tags', value: ProfileTags.setTag(this.profile.tags, type, tag) })
      }
    },
    setTagFn (type) {
      return tag => {
        this.set({ name: 'tags', value: ProfileTags.setTag(this.profile.tags, type, tag) })
      }
    },
    removeTagFn (type) {
      return tag => {
        this.set({ name: 'tags', value: ProfileTags.removeTag(this.profile.tags, type, tag) })
      }
    },
    fetch () {
      if (!this.user) {
        this.records = []
      }
      Profile.queryByTypes(this.user.id).then(records => {
        this.records = records
      })
    }
  }
}
</script>
